import type { AuthorsStatus } from "@/lib/titleAuthors";
import { testIds } from "@/testIds";
import { TitleBlockView } from "../blocks/TitleBlockView";
import styles from "./TitleEditContent.module.scss";

/** An A4 page is 595 x 842 points; the paper column scales it to fit. */
const PAGE_W = 595;
const PAGE_H = 842;

interface PaperPreviewProps {
  title: string;
  author: string;
  status: AuthorsStatus;
  dateText: string;
  highlightSymbol: string | null;
  /** Width of the paper column in pixels. */
  width: number;
  /** A thumbnail: not something to look up by testid. */
  thumbnail?: boolean;
}

export function authorsNoticeFor(status: AuthorsStatus): string | undefined {
  if (status.kind === "foreign") return "The layout comes from your template. Compile to see it.";
  if (status.kind === "unbalanced") return `Close the ${status.brace} to see these authors here.`;
  return undefined;
}

/** The title block as it prints: the canvas renderer at paper scale. */
export function PaperPreview({ title, author, status, dateText, highlightSymbol, width, thumbnail }: PaperPreviewProps) {
  const scale = width / PAGE_W;
  return (
    <div className={styles.paperFrame} style={{ width, height: PAGE_H * scale }} data-testid={thumbnail ? undefined : testIds.titleEdit.preview}>
      <div className={styles.paper} style={{ width: PAGE_W, height: PAGE_H, transform: `scale(${scale})` }}>
        <TitleBlockView
          paper
          title={title}
          author={author}
          dateText={dateText}
          highlightSymbol={highlightSymbol}
          authorsNotice={authorsNoticeFor(status)}
        />
      </div>
    </div>
  );
}
